import React from 'react';
import { Thumbnail } from '@bynder/design-system';
import { IconSync } from '@bynder/icons';
import { Color } from 'packages/ds/ColorPicker/types';
import { hexToRgb } from '~/common/editor/editorHelper';
import { isGradientColor } from 'packages/pages/editor/RightSideMenu/FormComponents/ColorPicker/utils';
import { GradientThumbnail } from 'packages/ds/GradientThumbnail/GradientThumbnail';

type Props = {
    color: Color;
    shape: 'square' | 'circle';
    size?: 'xs' | 's';
    liveUpdate?: boolean;
};

export function ColorThumbnail({ color, shape, size, liveUpdate = false }: Props) {
    if (isGradientColor(color)) {
        return (
            <GradientThumbnail {...color} size={size} shape={shape}>
                {liveUpdate && <Thumbnail.Indicator backgroundColor="teal500" icon={<IconSync />} />}
            </GradientThumbnail>
        );
    }

    const bg = typeof color === 'string' ? hexToRgb(color, 1) : hexToRgb(color.color, color.opacity);

    return (
        <Thumbnail variant="content" backgroundColor={bg} size={size} shape={shape}>
            {liveUpdate && <Thumbnail.Indicator backgroundColor="teal500" icon={<IconSync />} />}
        </Thumbnail>
    );
}
